import React, { useState } from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import { FaChevronDown, FaTimes } from 'react-icons/fa';
import './FilterDropdown.scss';

interface FilterOption {
  value: string | number;
  label: string;
}

interface FilterDropdownProps {
  options: FilterOption[];
  selectedItems: FilterOption[];
  onChange: (selected: FilterOption[]) => void;
  placeholder?: string;
}

const FilterDropdown: React.FC<FilterDropdownProps> = ({
  options,
  selectedItems,
  onChange,
  placeholder = "Opciones"
}) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const handleToggleItem = (item: FilterOption) => {
    const isSelected = selectedItems.some(selected => selected.value === item.value);
    if (isSelected) {
      onChange(selectedItems.filter(selected => selected.value !== item.value));
    } else {
      onChange([...selectedItems, item]);
    }
  };

  const handleRemoveItem = (itemToRemove: FilterOption) => {
    onChange(selectedItems.filter(selected => selected.value !== itemToRemove.value));
  };

  const clearAll = () => {
    onChange([]);
  };

  return (
    <div className="filter-dropdown-container">
      <div className="filter-dropdown-content">
        {/* Selected items display */}
        {selectedItems.length > 0 && (
          <div className="selected-items">
            {selectedItems.map((item) => (
              <div key={item.value} className="selected-item-tag">
                <span>{item.label}</span>
                <Button
                  variant="none"
                  className="remove-item-btn"
                  onClick={() => handleRemoveItem(item)}
                >
                  <FaTimes />
                </Button>
              </div>
            ))}
            <Button
              variant="none"
              className="clear-all-btn"
              onClick={clearAll}
            >
              Limpiar
            </Button>
          </div>
        )}

        {/* Dropdown selector */}
        <Dropdown show={showDropdown} onToggle={setShowDropdown}>
          <Dropdown.Toggle 
            variant="none" 
            className="filter-dropdown-toggle"
            onClick={() => setShowDropdown(!showDropdown)}
          >
            {selectedItems.length > 0 
              ? `${selectedItems.length} seleccionado(s)`
              : placeholder
            }
            <FaChevronDown className="dropdown-icon" />
          </Dropdown.Toggle>

          <Dropdown.Menu className="filter-dropdown-menu">
            {options.length > 0 ? (
              options.map((item) => (
                <Dropdown.Item
                  key={item.value}
                  onClick={() => handleToggleItem(item)}
                  className={`filter-dropdown-item ${
                    selectedItems.some(selected => selected.value === item.value) ? 'selected' : ''
                  }`}
                >
                  <input
                    type="checkbox"
                    checked={selectedItems.some(selected => selected.value === item.value)}
                    onChange={() => {}} // Controlled by parent click
                    className="filter-checkbox"
                  />
                  <span>{item.label}</span>
                </Dropdown.Item>
              ))
            ) : (
              <Dropdown.Item disabled>No hay opciones disponibles</Dropdown.Item>
            )}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};

export default FilterDropdown;
